import { render, staticRenderFns } from "./PersonCommonPrescriptionsInfo.vue?vue&type=template&id=7a1fcb9a&scoped=true"
import script from "./PersonCommonPrescriptionsInfo.vue?vue&type=script&lang=js"
export * from "./PersonCommonPrescriptionsInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonCommonPrescriptionsInfo.vue?vue&type=style&index=0&id=7a1fcb9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1fcb9a",
  null
  
)

export default component.exports